import { hasError } from '../../../../../../../utils';
import { ButtonGroup, ErrorAlert, Icon, icons } from '../../../../../../generic';
import Button from '../../../../../../generic/Button';
import LabeledPasswordInput from '../../../../../../generic/Forms/LabeledPasswordInput';
import LabeledTextInput from '../../../../../../generic/Forms/LabeledTextInput';
import type { OrganizationsStore } from '../../../../../../../redux/organizations';

type AuthLdapStepBodyProps = {
  domain: string;
  ssoConfigurationStatus: OrganizationsStore['ssoConfigurationStatus'];
  username: string;
  password: string;
  setUsername(username: string): void;
  setPassword(password: string): void;
};

export const AuthLdapStepBody = ({
  domain,
  ssoConfigurationStatus,
  username,
  password,
  setUsername,
  setPassword,
}: AuthLdapStepBodyProps) => (
  <>
    <p className="margin-bottom-md">
      To claim the <span className="italic">{domain}</span> domain, please authenticate with your SSO configuration.
    </p>
    {hasError(ssoConfigurationStatus) && <ErrorAlert status={ssoConfigurationStatus} />}
    <LabeledTextInput labelVariant="legacy" label="Username" value={username} onChange={setUsername} />
    <LabeledPasswordInput label="Password" value={password} onChange={setPassword} />
  </>
);

type AuthLdapStepButtonsProps = {
  isValid: boolean;
  ssoConfigurationStatus: OrganizationsStore['ssoConfigurationStatus'];
  onCancel(): void;
  onSignIn(): void;
};

export const AuthLdapStepButtons = ({
  isValid,
  ssoConfigurationStatus,
  onCancel,
  onSignIn,
}: AuthLdapStepButtonsProps) => (
  <ButtonGroup>
    <Button type="secondary" onClick={onCancel}>
      Back
    </Button>
    <Button
      onClick={onSignIn}
      isDisabled={!isValid || ssoConfigurationStatus.loading}
    >
      {ssoConfigurationStatus.loading && (
        <span className="margin-right-xs">
          <Icon icon={icons.circleO} hasSpin />
        </span>
      )}
      Sign In
    </Button>
  </ButtonGroup>
);
